<template>
  <span
    @mouseover="hovered = true"
    @mouseleave="hovered = false"
  >
    <label class="formLabel">
      {{name}}
    </label>
    <textarea
      class="uppercase py-2 px-4 block w-full appearance-none leading-normal border placeholder-black placeholder-opacity-100"
      :class="{
        'bg-gray-100 border-black': disabled,
        'bg-white':!disabled&&!hovered,
        'bg-white font-semibold':!disabled&&hovered,
        'border-red-500 ':error,
        'border-black':!error
      }"
      cols="50"
      :rows="rows"
      :value="value"
      @input="updateValue($event.target.value)"
      :disabled="disabled"
      :placeholder="placeholder"
    >
    </textarea>
  </span>
</template>

<script>
export default {
  name: 'CustomTextareaFour',
  props: {
    name: String,
    value: [String, Number],
    placeholder: String,
    rows: {
      type: String,
      default: '4'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hovered: false
    }
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    },
    checkType (evt) {
      if (this.type === 'number') {
        var charCode = (evt.which) ? evt.which : evt.keyCode
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault()
        } else {
          return true
        }
      }
    }
  }
}
</script>

<style lang="scss">
</style>
